import React, { lazy } from 'react';
export function StorySection() {
  return <section className="bg-warmWhite py-20 px-4" data-id="element-181">
      <div className="max-w-5xl mx-auto" data-id="element-182">
        <h2 className="text-3xl md:text-4xl lg:text-5xl font-heading text-center text-navy mb-16 max-w-4xl mx-auto" data-id="element-183">
          "Por Qué Una Nutricionista Clínica Creó Un Sistema De Recetas Para
          Airfryer"
        </h2>

        <div className="flex flex-col md:flex-row gap-12 items-start" data-id="element-184">
          <div className="w-full md:w-1/3 flex flex-col items-center text-center" data-id="element-185">
            <div className="relative" data-id="element-186">
              <div className="absolute -inset-4 bg-gold/10 rounded-full blur-md" data-id="element-187" />
              <div className="w-56 h-56 rounded-full mb-6 overflow-hidden border-4 border-gold shadow-xl relative" data-id="element-188">
                <img src="https://cdn.magicpatterns.com/uploads/tjw6wMtM7RxzUV2XMrhdkE/AD_1.png" alt="Dra. Elena Martínez Solís" className="absolute inset-0 w-full h-full object-cover object-[center_35%]" style={{
                aspectRatio: '1/1'
              }} width={768} height={768} loading="lazy" decoding="async" data-id="element-189" />
              </div>
            </div>
            <h3 className="text-xl font-bold text-navy mb-1" data-id="element-190">
              Dra. Elena Martínez Solís
            </h3>
            <p className="text-sm text-gold font-medium" data-id="element-191">
              Nutricionista Clínica Col. Nº AND-4821
            </p>
          </div>

          <div className="w-full md:w-2/3 space-y-6 text-lg text-gray-700 leading-relaxed" data-id="element-192">
            <p data-id="element-193">
              Llevo 12 años en consulta privada de nutrición clínica en España.
            </p>
            <p data-id="element-194">
              Y en todo ese tiempo, he visto el mismo patrón repetirse una y
              otra vez.
            </p>
            <p data-id="element-195">
              Mis pacientes llegaban con planes de alimentación perfectos sobre
              el papel. Planes equilibrados, variados, nutricionalmente
              impecables.
            </p>
            <p data-id="element-196">Y aun así, los abandonaban.</p>
            <p data-id="element-197">No por falta de motivación. No por falta de ganas.</p>
            <p className="font-bold text-xl text-navy" data-id="element-198">
              Los abandonaban porque eran imposibles de ejecutar.
            </p>
            <p data-id="element-199">
              Porque una cosa es saber qué comer. Y otra muy distinta es tener
              la energía, el tiempo y la logística para hacerlo cuando llegas a
              casa a las 20:30h con el cerebro frito.
            </p>
            <p data-id="element-200">
              Fue entonces cuando empecé a obsesionarme con una pregunta
              diferente:
            </p>
            <p className="italic font-medium text-navy border-l-4 border-gold pl-4 py-2 bg-cream rounded-r-xl" data-id="element-201">
              "¿Cuál es la dieta más efectiva que una persona real pueda
              mantener sin que le destroce la vida?"
            </p>
            <p data-id="element-202">
              La respuesta llegó cuando una de mis pacientes me trajo su
              Airfryer a consulta.
            </p>
            <p data-id="element-203">Literalmente.</p>
            <p data-id="element-204">
              Me dijo:{' '}
              <span className="italic" data-id="element-205">
                "Dra. Martínez, compré esto para adelgazar y no sé cómo usarlo."
              </span>
            </p>
            <p data-id="element-206">
              Pasé los siguientes 8 meses desarrollando, probando y refinando lo
              que hoy es{' '}
              <span className="font-bold text-navy" data-id="element-207">El Sistema 10-3-1</span>.
            </p>
            <p className="font-bold text-xl text-white bg-teal inline-block px-4 py-2 rounded-xl shadow-md" data-id="element-208">
              10 minutos de cena. 3 ingredientes base. 1 máquina.
            </p>
            <p data-id="element-209">
              Los resultados en consulta fueron tan consistentes que decidí
              convertirlo en un programa accesible para cualquier mujer en
              España.
            </p>
            <p data-id="element-210">Hoy más de 1.200 personas ya lo están usando.</p>
            <p className="font-bold text-navy" data-id="element-211">
              Y los resultados siguen siendo los mismos.
            </p>
          </div>
        </div>
      </div>
    </section>;
}